// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gqnaN8RudTOdxw {
  position: absolute;
  top: var(--ds-space-0, 0);
  right: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  border-radius: 8px;
}
.gqnaN8RudTOdxw:focus {
  outline: var(--ds-border-focused, #388bff) auto 2px;
  outline-offset: 2px;
}
.mac .gqnaN8RudTOdxw:focus {
  outline-color: -webkit-focus-ring-color;
}
.gqnaN8RudTOdxw:focus .mac.firefox {
  outline-color: AccentColor;
}
.TScnIQPbkMQo_l {
  width: unset;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardLink": `gqnaN8RudTOdxw`,
	"boardCard": `TScnIQPbkMQo_l`
};
export default ___CSS_LOADER_EXPORT___;
